<template>
  <LsModal
    :title="title"
    track-id="leads_confirm_hired_modal"
    class="leads-confirm-hired-modal--container"
  >
    <template #footer>
      <LsButton
        text="yes, i hired this pro"
        track-id="leads_confirm_hired_modal-yes"
        @click="yes"
      />
      <LsButton
        text="no, i am not ready to hire"
        track-id="leads_confirm_hired_modal-no"
        @click="close"
      />
    </template>
  </LsModal>
</template>

<script>
import { LsButton, LsModal } from '@/components/common';
import { lsFilters } from 'ls-vue-common';
import VueTypes from 'vue-types';
import { mapActions } from 'vuex';
import { CUSTOMER_LEADS__HIRE_PRO } from '@/store/types';

export default {
  name: 'LeadsConfirmHiredModal',
  components: {
    LsButton,
    LsModal,
  },
  props: {
    contractor: VueTypes.shape({
      user: VueTypes.shape({
        first_name: VueTypes.string.isRequired,
        last_name: VueTypes.string,
      }).isRequired.loose,
      name: VueTypes.string.isRequired,
    }).isRequired.loose,
    propertyId: VueTypes.number.isRequired,
    contactId: VueTypes.number.isRequired,
    customerLeadId: VueTypes.number.isRequired,
  },
  computed: {
    title() {
      return `Did you hire ${lsFilters.fullName({ user: this.contractor.user })} at ${
        this.contractor.name
      }?`;
    },
  },
  methods: {
    ...mapActions([CUSTOMER_LEADS__HIRE_PRO]),
    yes() {
      const { propertyId, contactId, customerLeadId } = this;
      this[CUSTOMER_LEADS__HIRE_PRO]({
        customerLeadId,
        propertyId,
        contactId,
        onSuccess: this.onSuccess,
      });
    },
    close() {
      this.$parent.close();
    },
    onSuccess() {
      this.$parent.close();
      if (this.$router.currentRoute.name !== 'services') {
        this.$router.push({
          name: 'services',
          path: '/services',
        });
      }
    },
  },
};
</script>

<style lang="scss">
.leads-confirm-hired-modal--container {
  .modal-footer {
    button:first-of-type {
      margin-right: 5px;
    }

    button:last-of-type {
      margin-left: 5px;
    }

    @media (max-width: $mobile-max-width) {
      flex-direction: column;

      button:first-of-type {
        margin-right: 0;
        margin-bottom: 10px;
      }

      button:last-of-type {
        margin-left: 0;
      }
    }
  }
}
</style>
